import React from "react";
import ProductBanner from "./components/product-banner";
import { INVOICE_FINANCING_INFO, PRODUCTS } from "../../constants/products";
import ProductBenefit, {
  ProductBenefitContent,
} from "./components/product-benefit";
import lowInterestIcon from "../../assets/images/products/low-interest.png";
import instantPayIcon from "../../assets/images/products/instant-pay.png";
import transparantIcon from "../../assets/images/products/transparancy.png";
import { Container } from "react-bootstrap";
import ProductClosingStatement from "./components/product-closing-statement";
import ProductHow, { ProductHowContent } from "./components/product-how";

const CONTENTS: ProductBenefitContent[] = [
  {
    title: "Bebas Biaya",
    image: transparantIcon,
    description: `Tidak ada biaya administrasi dan provisi di awal.`,
  },
  {
    title: "Pencairan Cepat",
    image: instantPayIcon,
    description:
      "Dana diterima dalam waktu maksimal 3 jam setelah invoice diterima.",
  },
  {
    title: "Bunga Rendah",
    image: lowInterestIcon,
    description: `Bunga antara ${Intl.NumberFormat("id-ID").format(INVOICE_FINANCING_INFO.interestRate.start)} - ${Intl.NumberFormat("id-ID").format(INVOICE_FINANCING_INFO.interestRate.end)}% per bulan, dengan tenor maksimal 12 bulan.`,
  },
];

function InvoiceFinancing() {
  const product = PRODUCTS.invoiceFinancing;

  const CONTENT_HOW: ProductHowContent[] = [
    {
      title: "Pendaftaran",
      description: (
        <React.Fragment>
          Pendaftaran mandiri melalui{" "}
          <a href={product.link} target="_blank" rel="noreferrer">
            website Pohon Dana
          </a>{" "}
          dengan menyertakan invoice dan legalitas perusahaan.
        </React.Fragment>
      ),
    },
    {
      title: "Verifikasi",
      description: (
        <React.Fragment>
          Tim Pohon Dana memverifikasi invoice dan data peminjam dan
          mempertimbangkan kemampuan bayar.
        </React.Fragment>
      ),
    },
    {
      title: "Persetujuan",
      description: (
        <React.Fragment>
          Tim Pohon Dana menginformasikan nominal yang akan dicairkan dan tenor
          yang disetujui. Peminjam berhak menyetujui atau menolak tawaran yang
          diberikan.
        </React.Fragment>
      ),
    },
    {
      title: "Proses Pencairan",
      description: (
        <React.Fragment>
          Pinjaman diteruskan ke pihak pemberi pinjaman untuk dilakukan proses
          pengiriman dana ke rekening peminjam. Proses ini memakan waktu sekitar
          2 jam.
        </React.Fragment>
      ),
    },
  ];

  return (
    <div className="main-container" id="product-page">
      <ProductBanner product={product} />
      <Container className="my-5">
        <ProductBenefit
          title={
            <React.Fragment>
              <span className="text-primary-main">Keuntungan</span>{" "}
              {product.title}
            </React.Fragment>
          }
          contents={CONTENTS}
        />
        <div className="mt-4 text-secondary text-size-label text-center">
          Biaya Keterlambatan - 1,5% per bulan (pro rata)
        </div>

        <div className="mt-5 pt-5">
          <ProductHow product={product} contents={CONTENT_HOW} />
        </div>
        <ProductClosingStatement
          caption="Butuh dana instan?"
          title="Ubah Invoice anda di Pohon Dana!"
          product={product}
          buttonText="Ajukan Pinjaman"
        />
      </Container>
    </div>
  );
}

export default InvoiceFinancing;
